import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type FuelTypeCategoriesRequest = CommonTableRequest;

export interface FuelTypeCategory {
    id: number;
    name: string | null;
    isBuiltIn: boolean;
    isActive: boolean;
    createdAtUTC: string;
    updatedAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface FuelTypeCategoriesResponse {
    data: FuelTypeCategory[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateFuelTypeCategoryRequest {
    name: string;
}

export type UpdateFuelTypeCategoryRequest = CreateFuelTypeCategoryRequest;

export const getApiFuelTypeCategories = (
    clientId: number,
    tenantAlias: string,
    payload: FuelTypeCategoriesRequest,
): Promise<FuelTypeCategoriesResponse> =>
    httpApi
        .post<FuelTypeCategoriesResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-type-categories/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiFuelTypeCategory = (
    clientId: number,
    tenantAlias: string,
    payload: CreateFuelTypeCategoryRequest,
): Promise<FuelTypeCategory> =>
    httpApi
        .post<FuelTypeCategory>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-type-categories`, payload)
        .then(({ data }) => data);

export const updateApiFuelTypeCategory = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateFuelTypeCategoryRequest,
): Promise<FuelTypeCategory> =>
    httpApi
        .put<FuelTypeCategory>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-type-categories/${id}`,
            payload,
        )
        .then(({ data }) => data);

export const deleteApiFuelTypeCategory = (
    clientId: number,
    tenantAlias: string,
    id: number,
): Promise<FuelTypeCategory> =>
    httpApi
        .delete<FuelTypeCategory>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-type-categories/${id}`)
        .then(({ data }) => data);
